import type { GridColDef } from '@mui/x-data-grid';
import type { User } from '../types';
import { CellContainer, CellTypography } from '../components/AccountsGrid.styles';
import { UserRole, UserRoleTitle } from 'features/login';

const columnsAdditionalOptions = {
  disableColumnFilter: true,
  disableColumnMenu: true,
};

export const useUsersColumns = (): GridColDef<User>[] => {
  return [
    {
      field: 'email',
      headerName: 'Email',
      width: 250,
      ...columnsAdditionalOptions,
      sortable: false,
      renderCell: ({ row }) => (
        <CellContainer>
          <CellTypography variant={'body2'}>{row.email ?? '-'}</CellTypography>
        </CellContainer>
      ),
    },
    {
      field: 'apps',
      headerName: 'Projects',
      width: 250,
      ...columnsAdditionalOptions,
      sortable: false,
      renderCell: ({ row }) => (
        <CellContainer>
          <CellTypography variant={'body2'}>
            {row.role === UserRole.SUPERUSER
              ? 'All'
              : (row.apps.join(', ') ?? '-')}
          </CellTypography>
        </CellContainer>
      ),
    },
    {
      field: 'groups',
      headerName: 'Networks and permissions',
      width: 260,
      ...columnsAdditionalOptions,
      sortable: false,
      renderCell: ({ row }) => (
        <CellContainer>
          <CellTypography variant={'body2'}>
            {row.role === UserRole.SUPERUSER
              ? 'All'
              : (row.groups.map(g => g.name).join(', ') ?? '-')}
          </CellTypography>
        </CellContainer>
      ),
    },
    {
      field: 'role',
      headerName: 'Access level',
      width: 180,
      ...columnsAdditionalOptions,
      sortable: false,
      renderCell: ({ row }) => (
        <CellContainer>
          <CellTypography variant={'body2'}>
            {row.role ? UserRoleTitle[row.role] : '-'}
          </CellTypography>
        </CellContainer>
      ),
    },
  ];
};